import { useContext } from 'react'
import VIEW_BREAKPOINTS from '../../constants/view-breakpoints'
import viewportContext from '../../contexts/viewport'

const useViewport = () => {
    const {
        width,
        height,
        breakpoint
    } = useContext(viewportContext)

    return {
        breakpoints: VIEW_BREAKPOINTS,
        width,
        height,
        breakpoint,
        isMobile: breakpoint < VIEW_BREAKPOINTS.LG,
        isXs: breakpoint === VIEW_BREAKPOINTS.XS,
        isSm: breakpoint === VIEW_BREAKPOINTS.SM,
        isMd: breakpoint === VIEW_BREAKPOINTS.MD,
        isLg: breakpoint === VIEW_BREAKPOINTS.LG,
        isXl: breakpoint === VIEW_BREAKPOINTS.XL,
    }
}
  
export default useViewport